import { useEffect, useState } from "react";
import axios from "axios";
import { Eye } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Small live "X personnes regardent" badge.
 * Pings the backend once on mount, polls watcher count every 20s.
 */
export default function PeopleWatching({ slug }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    if (!slug) return;
    let mounted = true;
    axios.post(`${API}/products/${slug}/ping`).catch(() => {});
    const fetchCount = () => {
      axios.get(`${API}/products/${slug}/watching`).then((r) => {
        if (mounted) setCount(r.data?.count ?? null);
      }).catch(() => {});
    };
    fetchCount();
    const id = setInterval(fetchCount, 20000);
    return () => { mounted = false; clearInterval(id); };
  }, [slug]);

  if (count == null || count <= 0) return null;
  return (
    <p className="inline-flex items-center gap-1.5 text-xs text-coral" data-testid="people-watching">
      <Eye size={14} />
      <span><strong>{count}</strong> {count > 1 ? "personnes regardent" : "personne regarde"} ce produit</span>
    </p>
  );
}
